import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { useTabHandlerStringKeys } from '../../hooks/useTabHandler';
import { IncidentsTab } from './Incidents/IncidentsTab';
import { MobileDevicesTab } from './MobileDevices/MobileDevicesTab';
import { NotificationsTab } from './Notifications/NotificationsTab';
import { RulesetsTab } from './Rulesets/RulesetsTab';
import { SubscriptionsTab } from './Subscriptions/SubscriptionsTab';
const debug = process.env.REACT_APP_DEBUG && false;
export const NotificationTabs = (props) => {
    const tabsToDisplay = {
        'Rule Sets': () => _jsx(RulesetsTab, { ...props }),
        Incidents: () => _jsx(IncidentsTab, { ...props }),
        Subscriptions: () => _jsx(SubscriptionsTab, { ...props }),
        'User Devices': () => _jsx(MobileDevicesTab, { ...props }),
        Notifications: () => _jsx(NotificationsTab, { ...props }),
    };
    const { state: [[tabValue]], handlers: { handleTabChange }, } = useTabHandlerStringKeys(tabsToDisplay);
    return props.user ? (_jsxs(TabContext, { value: tabValue, children: [_jsx(TabList, { onChange: handleTabChange, children: Object.entries(tabsToDisplay).map(([name], i) => (_jsx(Tab, { value: name, label: name }, `tabHeader_${i}`))) }), Object.entries(tabsToDisplay).map(([name, tab]) => (_jsx(TabPanel, { value: name, sx: { padding: 0, paddingBlockStart: 1 }, children: tab() }, `tabBase_${name}`)))] })) : (_jsx(_Fragment, {}));
};
